import { Input } from '@pancakeswap/uikit'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useWeb3React } from '@/hooks/useWeb3React'
import { senderToken, senderTokenChange } from '@/store'
import { TokenType } from '@/store/type'
import { SenderMainInfo } from '@/config'
import { CascaderSwapper, ShowTokenInfo, ShowTokenInfoItem } from './style'


const App = ({ valueChange }) => {
  const dispatch = useDispatch()
  const { chainId } = useWeb3React()
  const { address } = useSelector(senderToken)

  const [mainList, setMainList] = useState<TokenType[]>([])
  const [show, setShow] = useState(false)

  const inputValueChanged = (e: { target: { value: string, name: string } }) => {
    valueChange(e.target.value.trim())
    setShow(false)
  }

  useEffect(() => {
    if (chainId) setMainList(SenderMainInfo[chainId])
  }, [chainId])

  const showTokenInfo = () => {
    setShow(true)
  }

  const infoItemClick = (item: TokenType) => {
    setShow(false)
    dispatch(senderTokenChange(item))
  }
  const moveLeave = () => {
    setShow(false)
  }

  return (
    <CascaderSwapper infoHeight={mainList.length}>
      <Input name='address' onClick={showTokenInfo} value={address} onChange={inputValueChanged} />
      <ShowTokenInfo className={`${show ? 'comp show' : 'comp'}`} onMouseLeave={moveLeave}>
        {mainList.map((item, index) => (
          <ShowTokenInfoItem key={index} onClick={() => infoItemClick(item)}>
            <div>{item?.symbol}</div>
            <div>{item.address}</div>
          </ShowTokenInfoItem>
        ))}
      </ShowTokenInfo>
    </CascaderSwapper>
  )
}

export default App
